module.exports = __webpack_public_path__ + "img/banner-2.208a15f2.png";